const EntidadeEventoEnum = {
  PARCEIRA: 0,
  PRINCIPAL: 1,
}

export default EntidadeEventoEnum
